import MarkdownRenderer from './MarkdownRenderer';
import PortableTextRenderer from './PortableTextRenderer';

const SanityPostRenderer = ({post}) => {
  const {body = [], markdownBody = []} = post;

  return markdownBody ? (
    <MarkdownRenderer post={markdownBody} />
  ) : (
    <PortableTextRenderer post={body} />
  );
};

export default SanityPostRenderer;
